import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Form as FinalForm } from 'react-final-form';

import type { IDepsDesktop, TForm } from '../models';
import { Form as Component } from '../form';
import { SafeguardDesktop as Safeguard } from '../../safeguard/desktop/desktop';

import styles from './desktop.css';

// eslint-disable-next-line styler/check-styler
export const FormDesktop = createWidget<IDepsDesktop, TForm>({
    FinalForm,
    Safeguard,
    styles,
    isMobile: false,
})(Component);
